import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface GlobalSearchResult {
  id: string;
  type: string;
  label: string;
  subtitle: string;
  route: string;
  icon: string;
}

export interface GlobalSearchGroup {
  key: string;
  label: string;
  results: GlobalSearchResult[];
}

export interface GlobalSearchResponse {
  query: string;
  limit: number;
  groups: GlobalSearchGroup[];
}

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.restApiUrl}global-search`;

  search(query: string, limit: number, owningCompanyId?: number | null): Observable<GlobalSearchResponse> {
    let params = new HttpParams()
      .set('q', query)
      .set('limit', String(limit));

    if (owningCompanyId != null) {
      params = params.set('owningCompanyId', String(owningCompanyId));
    }

    return this.http.get<GlobalSearchResponse>(this.baseUrl, { params });
  }
}
